<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import 'normalize.css';

export default {
  name: 'app',
};
</script>

<style>
#app {
  min-height: 100vh;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  font-size: 80%;
  background: #fff;
}

textarea {
  resize: vertical;
}

.main::-webkit-scrollbar {
  display:none;
}

input {
  outline: none;
}

.search {
  margin-bottom: 1rem;
}

.error-text {
  color:#dd0f3b;
  margin-top: 5px;
  margin-left:5px;
}

</style>
